import React, { useEffect, useState } from 'react';

export default function SuccessScreen({ firstName, email, referenceNumber, onReturn }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4 py-12" style={{ background: '#fff' }}>
      <div
        className={`flex flex-col items-center text-center max-w-md transition-all duration-700 ${
          visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
      >
        {/* Spinning WIN Coin */}
        <div className="mb-8 relative">
          <div
            className="w-28 h-28 rounded-full flex items-center justify-center shadow-2xl"
            style={{
              background: 'linear-gradient(135deg, #D4A520, #F0C842, #D4A520)',
              animation: 'spin-coin 3s ease-in-out infinite',
              boxShadow: '0 0 40px rgba(212,165,32,0.5)',
            }}
          >
            <img
              src="/assets/images/Golden_coins_Win_Logo-1772863636273.png"
              alt="WIN Coin"
              className="w-20 h-20 object-contain"
            />
          </div>
          {/* Glow rings */}
          <div
            className="absolute inset-0 rounded-full"
            style={{
              background: 'radial-gradient(circle, rgba(212,165,32,0.2) 0%, transparent 70%)',
              animation: 'pulse-glow 2s ease-in-out infinite',
            }}
          />
        </div>

        <style>{`
          @keyframes spin-coin {
            0%, 100% { transform: rotateY(0deg); }
            25% { transform: rotateY(20deg); }
            75% { transform: rotateY(-20deg); }
          }
          @keyframes pulse-glow {
            0%, 100% { transform: scale(1); opacity: 0.6; }
            50% { transform: scale(1.3); opacity: 0.2; }
          }
        `}</style>

        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full mb-4" style={{ background: 'rgba(212,165,32,0.1)', border: '1px solid rgba(212,165,32,0.3)' }}>
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M2 7l3 3 7-7" stroke="#D4A520" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <span className="text-xs font-bold tracking-widest uppercase" style={{ color: '#D4A520' }}>Application Submitted</span>
        </div>

        <h1 className="text-3xl font-bold mb-4" style={{ color: '#0B1F3B', fontFamily: 'Cormorant Garamond, serif' }}>
          Application Submitted!
        </h1>

        <p className="text-base mb-6 leading-relaxed" style={{ color: '#374151' }}>
          Thank you <strong style={{ color: '#0B1F3B' }}>{firstName}</strong>! Your application is under review.
          Our team will contact you at <strong style={{ color: '#D4A520' }}>{email}</strong> within 5 business days.
        </p>

        <div className="w-full p-4 rounded-xl mb-8" style={{ background: '#0B1F3B' }}>
          <p className="text-xs font-semibold uppercase tracking-widest mb-1" style={{ color: 'rgba(255,255,255,0.5)' }}>Application Reference Number</p>
          <p className="text-xl font-bold tracking-wider" style={{ color: '#D4A520', fontFamily: 'monospace' }}>{referenceNumber}</p>
          <p className="text-xs mt-1" style={{ color: 'rgba(255,255,255,0.4)' }}>Save this number for your records</p>
        </div>

        <div className="flex flex-col gap-3 w-full">
          <div className="flex items-center gap-3 p-3 rounded-xl" style={{ background: '#F9FAFB' }}>
            <div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0" style={{ background: 'rgba(212,165,32,0.15)' }}>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M8 1l1.8 3.6L14 5.5l-3 2.9.7 4.1L8 10.4l-3.7 2.1.7-4.1-3-2.9 4.2-.9L8 1z" fill="#D4A520"/>
              </svg>
            </div>
            <p className="text-sm" style={{ color: '#374151' }}>Applications reviewed within <strong>5 business days</strong></p>
          </div>
          <div className="flex items-center gap-3 p-3 rounded-xl" style={{ background: '#F9FAFB' }}>
            <div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0" style={{ background: 'rgba(212,165,32,0.15)' }}>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M8 1l1.8 3.6L14 5.5l-3 2.9.7 4.1L8 10.4l-3.7 2.1.7-4.1-3-2.9 4.2-.9L8 1z" fill="#D4A520"/>
              </svg>
            </div>
            <p className="text-sm" style={{ color: '#374151' }}>WIN Verified badge awarded to <strong>approved businesses</strong></p>
          </div>
        </div>

        <button
          onClick={onReturn}
          className="mt-8 w-full py-4 rounded-xl font-bold text-base text-white transition-all duration-200 hover:opacity-90"
          style={{ background: '#0B1F3B' }}
        >
          Return to WIN
        </button>
      </div>
    </div>
  );
}
